import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { HaHeaderServiceService } from '../../services/HaHeader.service';
import { HaProfileInfo } from '../ha-models/ha-profile-info';
import { Router } from '@angular/router';
import { WebUserDetails } from '../../../../shared/models/WebUserDetails';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';

@Component({
  selector: 'app-ha-sidebar',
  templateUrl: './ha-sidebar.component.html',
  styleUrls: ['./ha-sidebar.component.css']
})

export class HaSidebarComponent implements OnInit {
  profileInfo: HaProfileInfo;
  manage: boolean = false;
  list: boolean = false;
  userRoleHa: string = null;
  viewIs;
  profileUrl: string = "";
  navCounter: boolean = false;
  currentUserHa: WebUserDetails;
  allUsersHa: WebUserDetails[];
  screenHeightSidebarHa: any;
  screenWidthSidebarHa: any;
  constructor(private _service: HaHeaderServiceService, private router: Router) {
    router.events.subscribe((val) => {
      this.viewIs = window.location.href;
      var lastSlash = window.location.href.lastIndexOf('/');
      this.viewIs = this.viewIs.substr(lastSlash + 1);
    });
    this.getScreenSizeSidebarHA();
  }

  //input for value from parent to child
  @Input() navCounterInput: boolean = false;
  //output for value from child to parent emitting event
  @Output() navCounterOutput = new EventEmitter();

  ngOnInit() {
    this.getProfileInfo();
    this.manage = false;
    this.list = false;
    this.allUsersHa = JSON.parse(localStorage.getItem('userDetails'));
    if (this.allUsersHa != undefined && this.allUsersHa != null) {
      this.currentUserHa = this.allUsersHa.filter(i => i.id == JSON.parse(sessionStorage.getItem('Id')))[0];
    }
    if (this.currentUserHa != null && this.currentUserHa != undefined) {
      this.userRoleHa = this.currentUserHa.userRole;
    }
  }

  @HostListener('window:resize', ['$event'])
  getScreenSizeSidebarHA(event ? ) {
    this.screenHeightSidebarHa = window.innerHeight;
    this.screenWidthSidebarHa = window.innerWidth;
  }
  public activeElement = 1;
  public selectedItem(id) {
    this.activeElement = id;
    if (this.screenWidthSidebarHa < 998) {
      this.functionAfterHeightHA();
    }
  }

  functionAfterHeightHA() {
    this._service.onSidebarClickedMobileViewHA();
  }

  getProfileInfo() {
    this._service.getProfileData().subscribe(
    (data: HaProfileInfo) => {
      this.profileInfo = data;
      if (this.profileInfo !== undefined && this.profileInfo !== null) {
        if (this.profileInfo.photoUrl !== undefined && this.profileInfo.photoUrl !== null && this.profileInfo.photoUrl !== "") {
          this.profileUrl = this.profileInfo.photoUrl
        } else {
          this.profileUrl = "";
        }
      }
    },
    (error) => {
      AlertMessages.Show('Failed', 'Could not load Profile!', AlertType.Error);
    });
  }

  toggleNavBar() {
    let status = this.navCounter == false ? true : false;
    this.navCounterInput = status;
    this.navCounter = status;
    this.navCounterOutput.emit(this.navCounterInput);
  }
}
